import "./styles.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useConfig } from "../../context/ConfigContext";
import { useTranslation } from "react-i18next";
import { generateUUID } from "../../services/uidService";
import { useUID } from "../../context/UIDContext";
import { useAmplitude } from "../../context/AmplitudeContext";
import Button from "../Button/Button";
import { HairDownIcon } from "../icons/HairDownIcon";
import { ProductsBottleIcon } from "../icons/ProductsBottleIcon";
import { MapPositionIcon } from "../icons/MapPositionIcon";

export const MobilePage = ({ onFinish }) => {
  const { t, i18n } = useTranslation(["customHomeInfo"]);
  const { uid, updateUID } = useUID();
  const trackEvent = useAmplitude();
  const { logo } = useConfig();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isScanned = params.get("scanned");
    const uid = generateUUID();

    updateUID(uid);

    // Log events if user scanned QR and visited on mobile
    // If user visited first time from QR-scan
    if (isScanned) {
      trackEvent("webapp_user_scanned_qr", uid);
      params.delete("scanned");
      // Update the URL without reloading the page
      navigate(
        {
          pathname: window.location.pathname,
          search: params.toString(),
        },
        { replace: true },
      );
    }

    trackEvent("webapp_user_visited_home", uid);
  }, [navigate, updateUID, trackEvent, i18n]);

  return (
    <>
      <img
        className="background-home-page-image"
        src="images/startpage_bg.png"
        alt="Background"
        width={100}
      />
      <div className="background-home-page-overlay" />
      <div className="home-page-contents-container">
        <img
          src={logo}
          alt="Logo"
          width="100"
          className="home-page-logo-image"
        />
        <h4 className="home-page-title">
          Welcome to our AI-inspired tool <strong>Know Your Curl</strong>{" "}
          brought to you by The Perfect Hair, local + natural + with you every
          step of the way
        </h4>
        <div className="home-page-items">
          <div className="home-page-item">
            <HairDownIcon className={"hair-icon"} />
            <p className="home-page-item-text">Know what curl type you are</p>
          </div>
          <div className="home-page-item">
            <ProductsBottleIcon />
            <p className="home-page-item-text">
              See what products work best for you
            </p>
          </div>
          <div className="home-page-item">
            <MapPositionIcon />
            <p className="home-page-item-text">
              Find a store near you OR go shop with us online
            </p>
          </div>
        </div>
      </div>
      <div className="home-button-wrapper">
        <Button
          text={t("custom-home-button")}
          onClick={() => {
            trackEvent("webapp_user_press_continue_home", uid);
            onFinish();
          }}
        />
      </div>
    </>
  );
};
